import { fr_FR, NzI18nInterface } from 'ng-zorro-antd/i18n';

export const customFrFR: NzI18nInterface = {
  ...fr_FR,
  QRCode: {
    ...fr_FR.QRCode,
    scanned: 'Scanné',  // Missing trad value
  },
  DatePicker: {
    ...fr_FR.DatePicker,
    lang: {
      ...fr_FR.DatePicker.lang,
      rangeQuarterPlaceholder: ['Trimestre de début', 'Trimestre de fin'],
    }

  }
};